import React from "react";
import PublicShell from "@/components/PublicShell";

export default function About() {
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-16">
        <div className="text-eyebrow text-[#4F4D45]">About</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-2">A grounded wallet for the way money moves in 2026.</h1>
        <p className="text-lg text-[#4F4D45] mt-6 leading-relaxed">
          FinVault was built around a simple belief: finance should feel calm. Not screaming dashboards. Not aggressive shades of neon. Just the right information at the right moment, with the safeguards you'd expect from a serious bank.
        </p>

        <div className="mt-12 space-y-10 text-[#0A0A08] leading-relaxed">
          <div>
            <h2 className="font-display text-2xl font-medium">What FinVault does</h2>
            <p className="text-[#4F4D45] mt-3">Open a Personal or Business account, in Demo or Live mode. Deposit funds from your bank card via PayPal. Transfer to other FinVault users instantly with their email or wallet ID. Withdraw to any external bank. Track every move from a clean, focused dashboard.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl font-medium">How we approach security</h2>
            <ul className="mt-4 space-y-2 text-[#4F4D45] list-disc list-inside">
              <li>Passwords are hashed with bcrypt — never stored in plaintext.</li>
              <li>Sessions use signed JWTs delivered via HTTP-only cookies.</li>
              <li>Email OTP verification on registration <em>and</em> every login.</li>
              <li>Optional TOTP 2FA (Google Authenticator, Authy, 1Password).</li>
              <li>Brute-force lockouts and rate-limited login attempts.</li>
              <li>PCI-aware card handling — we never store full PANs or CVVs.</li>
              <li>PayPal handles card processing; sensitive data never reaches our servers.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl font-medium">Demo vs Live</h2>
            <p className="text-[#4F4D45] mt-3">Demo accounts start with $1,000 of simulated funds, perfect for getting familiar with the flow. Live accounts use PayPal sandbox/production for real card-based deposits. You always have both wallets, side by side.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl font-medium">A note on this build</h2>
            <p className="text-[#4F4D45] mt-3">FinVault is a demonstration of modern fintech UX patterns and security primitives. It is not a chartered bank. Live mode uses PayPal's sandbox by default — no actual money moves unless connected to a production PayPal app.</p>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
